export default "__VITE_ASSET__$fnQ9ZctOvbCEkyq6hpHqA__"